// extracted by mini-css-extract-plugin
module.exports = {"frame":"Contract_frame__2ovnh"};